import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tv-confirmation-login-dialog',
  templateUrl: 'confirmation.login.dialog.component.html',
  styles: [`.button-align {text-align: right}`]
})
export class ConfirmationLoginDialogComponent {
  message: string;
  description: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationLoginDialogComponent>) {
    if (data) {
      this.message = data.message || this.message;
      this.description = data.description;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancel(): void {
    this.dialogRef.close(false);
  }

    onDiloagCancel() {
    console.log('popup closed');
    this.dialogRef.close();
  }
}
